import React from "react";
import CollapsibleSection from "./CollapsibleSection";
import DEALER_SERVICES from "../data/dealerServices";
import SPECIALTY_DESCRIPTIONS from "../data/dealerSpecialtyDescriptions";

const DealerServicesPanel = ({
    isOpen,
    onToggle,
    formData,
    setFormData,
    servicesRef,
}) => {
    const services = Array.isArray(formData.services) ? formData.services : [];
    const serviceDescriptions = formData.serviceDescriptions || {};

    return (
        <CollapsibleSection title="🛠️ Services" isOpen={isOpen} onToggle={onToggle}>
            <div className="form-section" ref={servicesRef}>
                <small className="note">
                    Select the services you offer. Then describe each one briefly below.
                </small>

                <div className="checkbox-grid">
                    {DEALER_SERVICES.map((type) => (
                        <label key={type}>
                            <input
                                type="checkbox"
                                value={type}
                                checked={services.includes(type)}
                                onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const updatedServices = isChecked
                                        ? [...services, type]
                                        : services.filter((t) => t !== type);

                                    const updatedDescriptions = { ...serviceDescriptions };

                                    if (isChecked && !updatedDescriptions[type]) {
                                        const options = SPECIALTY_DESCRIPTIONS[type] || [];
                                        updatedDescriptions[type] =
                                            options[Math.floor(Math.random() * options.length)] || "";
                                    } else if (!isChecked) {
                                        delete updatedDescriptions[type];
                                    }

                                    setFormData((prev) => ({
                                        ...prev,
                                        services: updatedServices,
                                        serviceDescriptions: updatedDescriptions,
                                    }));
                                }}
                            />
                            <span>&nbsp;{type}</span>
                        </label>
                    ))}

                    <div className="transfer-fee-input">
                        <label htmlFor="transferFee" className="descriptionTitle">
                            Transfer Fee (USD)
                        </label>
                        <input
                            id="transferFee"
                            type="number"
                            min="0"
                            placeholder="e.g. 25"
                            value={formData.transferFee || ""}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    transferFee: e.target.value,
                                }))
                            }
                        />
                    </div>

                </div>

                {services.map((type) => (
                    <div key={type} style={{ marginBottom: "1rem", marginTop: "1rem" }}>
                        <label className="descriptionTitle" htmlFor={`desc-${type}`}>
                            {type} Description
                        </label>
                        <textarea
                            id={`desc-${type}`}
                            rows={2}
                            placeholder={`Short description for ${type}`}
                            value={serviceDescriptions[type] || ""}
                            onChange={(e) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    serviceDescriptions: {
                                        ...prev.serviceDescriptions,
                                        [type]: e.target.value,
                                    },
                                }));
                            }}
                        />
                    </div>
                ))}
            </div>
        </CollapsibleSection>
    );
};

export default DealerServicesPanel;